import uploader from "@/components/Common/FileUploader/FileUploader.vue";

const FileUploader = {
  install: function (Vue) {
    Vue.component('fileUploader', uploader);
  }
}
export default FileUploader;